module.exports = __webpack_public_path__ + "static/media/circlecheck.2e6c0e1c.svg";